import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import globalTranslations from '../../../../i18n/globalTranslations';
import { modelOf } from '../../../../prop-types';
import CartStore from '../../../../store/CartStore';
import RequestState from '../../../../types/RequestState';
import Icon from '../../../common/Icon';

const NavigationCartText = ({ cartStore, className }) => {
  const renderPrice = () => {
    return cartStore.cart?.total?.text || '';
  };

  const renderCartText = () => {
    let text;

    switch (cartStore.state) {
      case RequestState.LOADED:
        if (!cartStore.hasCart || cartStore.cart.number_of_products === 0) {
          text = <FormattedMessage {...globalTranslations.cartEmptySentence} />;
        } else {
          text = (
            <span>
              <FormattedMessage
                {...globalTranslations.itemCount}
                values={{
                  count: cartStore.cart.number_of_products,
                }}
              />{' '}
              {renderPrice()}
            </span>
          );
        }
        break;
      case RequestState.LOADING:
      default:
        text = <FormattedMessage {...globalTranslations.loading} />;
        break;
    }

    return text;
  };

  return (
    <div
      className={classNames('NavigationCart', 'NavigationCartText', className)}
    >
      <Icon name="shopping-cart" />
      <span className={classNames('NavigationCart__cart-text')}>
        <span className="NavigationCart__cart-text-desktop">
          {renderCartText()}
        </span>
        {cartStore.hasCart && <span className="NavigationCart__cart-text-mobile">
          {renderPrice()}
        </span>}
      </span>
    </div>
  );
};

NavigationCartText.propTypes = {
  cartStore: modelOf(CartStore).isRequired,
  className: PropTypes.string,
};

export default inject('cartStore')(observer(NavigationCartText));
